var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme } from "@mui/material";
export var ItemGraph = function (_a) {
    var value = _a.value, color = _a.color, isRealValue = _a.isRealValue, isMainGraph = _a.isMainGraph;
    var theme = useTheme();
    return (_jsx(Box, __assign({ sx: { height: "100%", display: "flex", alignItems: "flex-end" } }, { children: _jsx(Box, { sx: __assign({ height: "".concat(value, "%"), borderTopLeftRadius: isRealValue ? 16 : 0, borderTopRightRadius: isRealValue ? 16 : 0, width: 74, background: color }, (isMainGraph && { zIndex: theme.zIndex.appBar })) }) })));
};
